import React from "react";
const content = () => {
  return (
    <>
       <div class="container-content" id="contact">
    <h2>More Deatils Collection</h2>
    <h3 class="offer">Please Send Me Your Email</h3>

    <div class="input-container">
      <input type="text" class="input-field" placeholder="You email address"/>
      <button class="button">SUBSCRIBE</button>
    </div>
  </div>
    </>
  );
};

export default content;
